<template>
  <div
    class="col-12"
    v-if="
      datas &&
      datas.transactions_by_week_date &&
      datas.transactions_by_week_date.length > 0 &&
      datas.transaction_by_means &&
      datas.transaction_by_means.length > 0 &&
      datas.last_30_days_success_transaction &&
      datas.last_30_days_success_transaction.length > 0
    "
  >
    <div class="row">
      <div
        class="col-xs-12 col-lg-6 col-md-6 mt-4"
        v-if="
          datas &&
          datas.transactions_by_week_date &&
          datas.transactions_by_week_date.length > 0
        "
      >
        <div class="chartBox p-4">
          <h5
            class="col-lg-12 col-12 convert mb-0 font-bold text-bold"
            style="background-color: #fff"
          >
            {{ $t("statistics_byday_and_week") }}
          </h5>
          <div class="col-12 convert mt-0" style="background-color: #fff">
            <bar-chart />
          </div>
        </div>
      </div>
      <div
        class="col-xs-12 col-lg-6 col-md-6 mt-4"
        v-if="
          datas &&
          datas.transaction_by_means &&
          datas.transaction_by_means.length > 0
        "
      >
        <div class="chartBox p-4">
          <h5 class="col-lg-12 col-12 mb-0">
            {{ $t("usermeans.title") }}
          </h5>
          <div class="col-12 mt-0 chart-container">
            <dougnut-chart />
          </div>
        </div>
      </div>
      <div
        class="col-xs-12 col-lg-12 col-md-12 mt-4"
        v-if="
          datas &&
          datas.last_30_days_success_transaction &&
          datas.last_30_days_success_transaction.length > 0
        "
      >
        <h6
          class="col-lg-12 col-12 convert mb-0"
          style="background-color: #fff"
        >
          {{ $t("menus.transactions") }}
        </h6>
        <div class="col-12 convert mt-0" style="background-color: #fff">
          <line-chart />
        </div>
      </div>
    </div>
  </div>
  <div
    class="col-12 alert alert-warning text-uppercase"
    style="border-radius: 0"
    v-else
  >
    {{ $t("none_activity") }}
  </div>
</template>

<script>
import BarChart from "../../charts/BarChart";
import LineChart from "../../charts/LineChart";
import DougnutChart from "../../charts/DougnutChart";
import { mapState } from "vuex";

export default {
  components: {
    BarChart,
    LineChart,
    DougnutChart,
  },
  name: "Test",
  computed: {
    ...mapState("dashboard", ["datas"]),
  },
};
</script>

<style scoped>
.convert {
  background: white;
}
.chartBox {
  background: #fff;
  width: 100%;
  height: 100%;
}
.chart-container {
  display: flex;
  justify-content: center; /* Center horizontally */
  align-items: center; /* Center vertically */
  height: 100%;
}
</style>
